// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2JGGF","noInteraction":"EventWrapper_noInteraction__3ROmc","pointerPassthrough":"EventWrapper_pointerPassthrough__2-TBg"};